import { useTranslation } from "react-i18next";

const cardTypeOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "visa",
      title: t("options.cardType.visa"),
      value: "VISA",
    },
    {
      key: "master",
      title: t("options.cardType.master"),
      value: "MASTER",
    },
    {
      key: "unionpay",
      title: t("options.cardType.unionpay"),
      value: "UNIONPAY",
    },
    {
      key: "amex",
      title: t("options.cardType.amex"),
      value: "AMEX",
    },
    {
      key: "jcb",
      title: t("options.cardType.jcb"),
      value: "JCB",
    },
    {
      key: "alipay",
      title: t("options.cardType.alipay"),
      value: "ALIPAY",
    },
    {
      key: "wechat",
      title: t("options.cardType.wechat"),
      value: "WECHAT",
    },
    {
      key: "payme",
      title: t("options.cardType.payme"),
      value: "PAYME",
    },
    {
      key: "octopus",
      title: t("options.cardType.octopus"),
      value: "OCTOPUS",
    }
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  if (typeof list === "function") {
    return options.filter(list);
  }
  return [];
};

export default cardTypeOptions;
